<div class="body">
  <!-- Use the standard ASCC module toolbar so the page header matches other administration pages. -->
  <mat-toolbar class="toolbar">
    <div class="full-width">
      <div class="row full-width align-items-center">
        <div class="col-sm-12 col-md-2 d-flex align-items-center">
          <span class="toolbar-title application-logs-title">Application Logs</span>
        </div>
        <div class="col-sm-12 col-md-4 d-flex align-items-center">
          <!-- Keep both log sources available from the page header. -->
          <mat-radio-group class="log-type" [value]="selectedLogType" (change)="selectLogType($event.value)" aria-label="Log type">
            <mat-radio-button value="system">System Logs</mat-radio-button>
            <mat-radio-button value="transaction">Transaction Logs</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-sm-12 col-md-4 type-header d-flex align-items-center">
          <!-- Keep the selected date available for both system and transaction logs. -->
          <mat-form-field appearance="outline" class="no-subscript log-date" *ngIf="dates.length">
            <mat-label>{{ selectedLogType == 'transaction' ? 'Transaction log date' : 'Log date' }}</mat-label>
            <mat-select [value]="selectedDate" (selectionChange)="selectDate($event.value)">
              <mat-option *ngFor="let item of dates" [value]="item.date">{{ item.date }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-icon-button color="primary" type="button" aria-label="Refresh logs" matTooltip="Refresh" [disabled]="loading" (click)="refreshLog()">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <div class="col-sm-12 col-md-2 type-header d-flex align-items-center" *ngIf="selectedLogType == 'system'">
          <!-- The control remains visible for all viewers; only Super Administrators can change it. -->
          <mat-form-field appearance="outline" class="no-subscript log-level" matTooltip="Minimum level recorded by Serilog">
            <mat-label>Minimum log level</mat-label>
            <mat-select [value]="selectedLogLevel" [disabled]="!canManageLogLevel || levelUpdating" (selectionChange)="changeLogLevel($event.value)">
              <mat-option *ngFor="let level of logLevels" [value]="level">{{ level }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <div class="container-fluid application-logs">
    <div class="alert alert-danger" *ngIf="error">{{ error }}</div>
    <div class="alert alert-danger" *ngIf="levelError">{{ levelError }}</div>
    <div class="alert alert-info" *ngIf="selectedLogType == 'system' && !loading && !error && !dates.length">No retained application logs were found.</div>
    <div class="alert alert-info" *ngIf="selectedLogType == 'transaction' && !loading && !error && !transactionLogs.length">No transaction logs were found.</div>
    <!-- Keep paging controls next to the content they navigate. -->
    <div class="d-flex log-navigation" *ngIf="selectedLogType == 'system' && log && log.totalPages > 1">
      <span class="log-page-number">Page {{ log.totalPages - currentPage + 1 }} of {{ log.totalPages }}</span>
      <button mat-mini-fab color="primary" type="button" aria-label="View first log page" matTooltip="First" [disabled]="loading || currentPage == log.totalPages" (click)="showFirst()">
        <mat-icon>first_page</mat-icon>
      </button>
      <button mat-mini-fab color="primary" type="button" aria-label="View older log entries" matTooltip="Older" [disabled]="loading || currentPage == log.totalPages" (click)="showOlder()">
        <mat-icon>navigate_before</mat-icon>
      </button>
      <button mat-mini-fab color="primary" type="button" aria-label="View newer log entries" matTooltip="Newer" [disabled]="loading || currentPage == 1" (click)="showNewer()">
        <mat-icon>navigate_next</mat-icon>
      </button>
      <button mat-mini-fab color="primary" type="button" aria-label="View last log page" matTooltip="Last" [disabled]="loading || currentPage == 1" (click)="showLast()">
        <mat-icon>last_page</mat-icon>
      </button>
    </div>
    <pre *ngIf="selectedLogType == 'system' && log && !loading"><span *ngFor="let line of logLines" class="log-line" [class.log-entry]="!!line.timestamp" [ngClass]="line.levelClass"><span *ngIf="line.timestamp" class="log-date-badge" [ngClass]="line.levelClass">{{ line.timestamp }}</span>{{ line.text }}</span></pre>
    <div class="transaction-log-list" *ngIf="selectedLogType == 'transaction' && !loading">
      <div class="transaction-log-header">
        <span>Date</span>
        <span>Action</span>
        <span>Entity</span>
        <span>Creator</span>
        <span>Description</span>
        <span>Endpoint</span>
      </div>
      <div class="transaction-log-entry" *ngFor="let transactionLog of transactionLogs" [ngClass]="getTransactionLogClass(transactionLog)" [matTooltip]="transactionLog.description || ''">
        <span class="transaction-log-date">{{ transactionLog.createdOn | date : 'MMM dd, yyyy, hh:mm:ss a' }}</span>
        <span class="transaction-log-name">{{ transactionLog.name || 'Transaction Log' }}</span>
        <span class="transaction-log-entity">{{ transactionLog.entityName || 'System' }}<ng-container *ngIf="(transactionLog.entityId ?? 0) != 0"> #{{ transactionLog.entityId }}</ng-container></span>
        <span class="transaction-log-creator">{{ transactionLog.createdByName || transactionLog.createdBy || '-' }}</span>
        <span class="transaction-log-description">{{ transactionLog.description || '-' }}</span>
        <span class="transaction-log-endpoint">{{ transactionLog.endPointName || '-' }}</span>
      </div>
    </div>
  </div>
</div>
